export const FILTER_NONE = "none";
export const FILTER_CALCULATED = "calculated";
export const FILTER_NOT_CALCULATED = "not_calculated";
